const StandardToneMapping = {
  id: "standard",
  helpersWGSL: "",
  callWGSL: `color*=scene.vImageInfos.x;color=1.0-exp2(-1.590579*color);`
};

export { StandardToneMapping };
//# sourceMappingURL=tone-mapping.js.map
